import { Common } from './common';

///////////////////////////////////////////////////
////// TYPES

export interface Geometry {
  longitude: string;
  latitude: string;
}

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async getStaticMapUrl(geometry: Geometry): Promise<string> {
    const url = this.common.constructPath('/patient-previsit/maps/static', {
      geometry,
    });

    const { staticMapUrl } = await this.common.getJSON(url);

    return staticMapUrl;
  }
}
